import { useState } from "react";
import { useInitFirestore } from "reactfire";
import "./styles.css";

export default function App() {
  const [initTime, setInitTime] = useState<number | null>(null);

  useInitFirestore(async (app) => {
    const startTime = new Date().getTime();
    console.time();
    const { getFirestore } = await import(
      /* webpackChunkName: "TEST" */ "firebase/firestore"
    );
    console.timeEnd();
    setInitTime(new Date().getTime() - startTime);
    return getFirestore(app);
  });

  return (
    <div className="App">
      <h1>Hello CodeSandbox</h1>
      <h2>Init time: {initTime}</h2>
    </div>
  );
}
